import type { Action, AppAbility, Subject } from '@/components/authnz/types/rbac';
import type { Decision } from './types';

/**
 * Minimal AppAbility view backed by an Access Decision — UI gates call `can` only.
 * Does not construct a parallel CASL Ability from roles.
 */
export function abilityFromDecision(decision: Decision): AppAbility {
  return {
    can(action: Action, subject: Subject) {
      return decision.can(action, subject);
    },
  } as AppAbility;
}
